import { connect } from "react-redux";
import { setCompo } from "../actions";
import Compo from "../components/Compo";

const mapStateToProps = (state) => ({
		refIndic: state.refIndic,
		currentCompo: state.setRef.compo,
		currentIndic: state.setRef.ref,
		territoire: state.setTerritoire,	
});

const mapDispatchToProps = (dispatch) => {
	return {
		clickCompo: (key) => {
			dispatch(setCompo(key));
		},
	};
};
const Systemic = connect(mapStateToProps, mapDispatchToProps)(Compo);
export default Systemic;
